export default __webpack_public_path__ + "static/media/apple.1bb61c00.svg";